/**
 * Education data
 */

export const educationData = [
  {
    id: 1,
    image: require('../images/company/imperial_logo.jpg'),
    imageAlt: 'Imperial College London logo',
    title: 'MEng Electronic and Information Engineering',
    subtitle: 'Imperial College London',
    date: '2020-2024',
    description: 'Relevant Modules',
    items: [
      'Principals of Distributed Ledgers',
      'Neuroscience for Machine Learning',
      'Optimisation',
      'Machine Learning for Imaging',
      'Deep Learning',
      'Coding Theory and Cryptography',
      'Maths for Signals and Systems',
      'Digital Signal Processing',
      'Machine Learning',
      'Computer Vision',
      'Embedded Systems',
      'High Level Programming',
      'Signals and Systems',
      'Instruction Architectures and Compilers',
      'Software Systems',
      'Discrete Mathematics',
      'Information Processing',
      'Mathematics for Engineers',
      'Thesis: Hyper Localised Environmental Modelling and Planning for Air Quality',
    ],
    wide: true,
  },
  {
    id: 2,
    image: require('../images/company/bma.png'),
    imageAlt: 'Brampton Manor Academy logo',
    title: 'A-Levels',
    subtitle: 'Brampton Manor Academy',
    date: '2018 - 2020',
    items: [
      'Maths - A* ',
      'Further Maths - A* ',
      'Physics - A* ',
      'Chemistry - A ',
    ],
  },
];

